import { SnakeStations } from './SnakeStations.js';

/**
 * Stations mode — passengers spawn at fixed station cells. Most of the actual
 * gameplay handling lives in SnakeStations.js + the scene's pickup branch in
 * _gameTick. This file owns just the setup that's unique to stations mode.
 */
export function createStations(scene) {
    const { cols, rows } = scene._grid;
    scene._stations = new SnakeStations(scene.game.theme);
    scene._stations.spawn(
        cols, rows,
        scene._snake, scene._obstacles, scene._perks,
        (c, r) => scene._isPickupBlocked(c, r),
    );
    scene._world.addChild(scene._stations.container);
}
